var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCueMateTennisLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}.cls-2{fill:#fff;}.cls-3{fill:#f30;}.cls-4{fill:#4d0f00;}.cls-5{fill:#36f;}.cls-6{fill:#0f1f4d;}.cls-7{fill:#0f3e0f;}.cls-8{fill:#3c3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CUE_MATE",
    "data-name": "CUE MATE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.22,8.12a.4.4,0,1,0,0-.8h-8V4.92h8a.4.4,0,1,0,0-.8h-8.4a.4.4,0,0,0-.4.4v6.4a.4.4,0,0,0,.4.4h8.4a.4.4,0,0,0,0-.8h-8V8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.06,4.12h-12a.4.4,0,0,0-.4.4v6.4a.4.4,0,1,0,.8,0v-6h5.2v6a.4.4,0,1,0,.8,0v-6h5.2v6a.4.4,0,0,0,.8,0V4.52A.4.4,0,0,0,81.06,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.43,7.62V4.52a.4.4,0,0,0-.4-.4H84.66a.4.4,0,0,0-.41.4v6.4a.41.41,0,0,0,.81,0V8.14h7.57v2.78a.4.4,0,1,0,.8,0V7.86a.5.5,0,0,0,0-.12A.37.37,0,0,0,93.43,7.62Zm-8.37-.28V4.92h7.57V7.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.19,4.12h-8.4a.4.4,0,0,0,0,.8h3.8v6a.4.4,0,1,0,.8,0v-6h3.8a.4.4,0,1,0,0-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,14.94H91.6a.38.38,0,0,0-.38.38v6.4a.37.37,0,0,0,.38.37.36.36,0,0,0,.37-.37v-6h7.65v6a.37.37,0,0,0,.38.37.36.36,0,0,0,.37-.37v-6.4A.37.37,0,0,0,100,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.38,14.94H103a.38.38,0,0,0-.38.38v6.4a.37.37,0,0,0,.38.37.36.36,0,0,0,.37-.37v-6H111v6a.37.37,0,0,0,.38.37.36.36,0,0,0,.37-.37v-6.4A.37.37,0,0,0,111.38,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.5,14.94a.38.38,0,0,0-.38.38v6.4a.37.37,0,0,0,.38.37.36.36,0,0,0,.37-.37v-6.4A.37.37,0,0,0,114.5,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.46,14.94h-8.4a.38.38,0,0,0-.38.38.37.37,0,0,0,.38.37h3.82v6a.37.37,0,0,0,.38.37.36.36,0,0,0,.37-.37v-6h3.83a.36.36,0,0,0,.37-.37A.37.37,0,0,0,77.46,14.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.48,15.69a.36.36,0,0,0,.37-.37.37.37,0,0,0-.37-.38h-8.4a.38.38,0,0,0-.38.38v6.4a.37.37,0,0,0,.38.37h8.4a.36.36,0,0,0,.37-.37.37.37,0,0,0-.37-.38h-8V18.89h8a.36.36,0,0,0,.37-.37.37.37,0,0,0-.37-.38h-8V15.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.27,18.16h-8V15.69h8a.37.37,0,0,0,.38-.37.38.38,0,0,0-.38-.38h-8.39a.38.38,0,0,0-.38.38v3.22a.38.38,0,0,0,.38.37h8v2.43h-8a.38.38,0,0,0-.38.38.37.37,0,0,0,.38.37h8.4a.37.37,0,0,0,.38-.37V18.54A.38.38,0,0,0,126.27,18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.86,22.3A9.3,9.3,0,0,1,25.73,8.48,1.3,1.3,0,0,1,28,9.75a6.7,6.7,0,1,0,11.71,0A1.3,1.3,0,0,1,42,8.48,9.3,9.3,0,0,1,33.86,22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.86,3.7A9.35,9.35,0,0,0,29.19,5a1.3,1.3,0,0,0-.47,1.78,1.32,1.32,0,0,0,1.13.64,1.26,1.26,0,0,0,.65-.17,6.68,6.68,0,0,1,6.73,0,1.26,1.26,0,0,0,.65.17A1.3,1.3,0,0,0,38.53,5,9.32,9.32,0,0,0,33.86,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.65,22.3A9.3,9.3,0,1,1,17.17,4.87a1.3,1.3,0,1,1-1.26,2.27,6.7,6.7,0,1,0,0,11.72,1.3,1.3,0,1,1,1.26,2.27A9.36,9.36,0,0,1,12.65,22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.57,7.68a1.28,1.28,0,0,0-.65.18,1.3,1.3,0,0,0-.47,1.78,6.72,6.72,0,0,1,0,6.72,1.3,1.3,0,0,0,.47,1.78,1.28,1.28,0,0,0,.65.18,1.3,1.3,0,0,0,1.12-.65,9.28,9.28,0,0,0,0-9.34,1.3,1.3,0,0,0-1.12-.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61,19.65a1.32,1.32,0,0,1-.9-.33A1.3,1.3,0,0,1,60,17.48a6.78,6.78,0,0,0,.81-1.12A1.3,1.3,0,0,1,63,17.65a9.53,9.53,0,0,1-1.13,1.56A1.3,1.3,0,0,1,61,19.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M64.17,11.5A9.3,9.3,0,1,0,55,22.3h0A9.44,9.44,0,0,0,57.53,22l.14,0a1.3,1.3,0,0,0-.74-2.5l-.11,0A6.62,6.62,0,0,1,55,19.7h0a6.7,6.7,0,1,1,6.57-8h-5.4a1.3,1.3,0,1,0,0,2.6h5.42a2.6,2.6,0,0,0,2.57-2.09A2.18,2.18,0,0,0,64.17,11.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCueMateTennisLogo);
export default __webpack_public_path__ + "static/media/Cue_Mate_Tennis_Logo.14bb23094c0d8bdc9ffc95f1d9471928.svg";
export { ForwardRef as ReactComponent };